<template>
    <div class="deposit-amount-wrapper">
        <div class="deposit-desktop withdraw-desktop d-flex">
            <div class="deposit-desktop__leftpage">

                <div class="withdraw-desktop__leftpage">
                    <div class="deposit-head">
                        <h3>Withdraw funds</h3>
                    </div>
                    <div class="page-help" data-bs-toggle="modal" data-bs-target="#withdrawal-help-modal">
                        <span class="page-help__text">Help</span>
                        <img class="page-help__img" src="@/assets/images/questionImg.webp" alt="questionImg">
                    </div>

                </div>
                <div class="page-subtitle notes">
                    <p>1. This form is for withdrawing the amount from the main wallet only.</p>
                    <p>2. The bonus wallet amount cannot be withdrawn by this form.</p>
                    <p>3. Do not put Withdraw request without betting with deposit amount. Such activity may
                        be identified as Suspicious</p>
                    <p>4. If multiple users are using same withdraw account then all the linked users
                        will be blocked.</p>
                    <p>5. Maximum Withdraw time is 45 minutes then only complain on WhatsApp number.</p>
                    <p>6. Withdrawal account should be same to deposit account.</p>
                </div>
            </div>
            <div class="deposit-desktop__rightpage">
                <div class="withdraw-rit-box deposit-amount-container">
                    <ul class="nav nav-tabs gap-2" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active px-2"  id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home"
                            type="button" role="tab" aria-controls="pills-home" aria-selected="true" @click="tabSetting('New Account')">Use New Account</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link px-2"  id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact"
                            type="button" role="tab" aria-controls="pills-contact" aria-selected="false" @click="tabSetting('Previous Account')">Use Previous Account</button>
                        </li>
                    </ul>
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                            <createAccount :records="records" :bankDetails = "bankDetails" :walletLimits = "walletLimits"  @createAccount ="addAccount"/>
                        </div>
                        <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                            <div class="amount-sec" v-if="userAccounts && userAccounts.length > 0">
                                <div class="match-odds-list-sec">
                                    <PreviousAccount :userAccounts ="userAccounts" :walletLimits = "walletLimits" :records="records"  @selectAmount = "selectAmount" @getPreviousBankDetails ="getPreviousBankDetails"/>
                                </div>
                            </div>
                            <div class="deposit top-cards_wrapper p-0 m-0" v-else-if="userAccounts">
                                <div class="page-subtitle notes ps-0">
                                    <p>No Account Available. Continue with new account!!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="deposit-and-withdrawal-sec mobile-amount-wrapper">
        <div class="container">
            <div class="withdraw-desktop__leftpage">
                <h2 class="page-title pt-1">Withdraw funds</h2>
                <div class="d-flex pt-2">
                    <div class="withdraw-rit-box withdraw-ui me-2">
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation" v-if="tabStatus == 'Previous Account'">
                                <button class="nav-link px-1" id="home-tab" data-bs-toggle="tab"
                                    data-bs-target="#mobile-use-new-account-tab" @click="tabSetting('New Account')">Create New Account</button>
                            </li>
                            <li class="nav-item" role="presentation" v-if="tabStatus == 'New Account'">
                                <button class="nav-link px-1" id="profile-tab" data-bs-toggle="tab"
                                    data-bs-target="#mobile-use-previous-account-tab" @click="tabSetting('Previous Account')">Use Previous Accounts</button>
                            </li>
                        </ul>
                    </div>
                    <div class="page-help" data-bs-toggle="modal" data-bs-target="#withdrawal-help-modal">
                        <span class="page-help__text">Help</span>
                        <img class="page-help__img" src="@/assets/images/questionImg.webp" alt="questionImg">
                    </div>
                </div>
            </div>
            <div class="withdraw-desktop__rightpage">
                <!-- <div class="page-subtitle subtitle-hidden">Please fill in all required fields</div> -->
                <div class="withdraw-rit-box mt-0">
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade" :class="{'show active' : tabStatus == 'New Account'}" id="mobile-use-new-account-tab" role="tabpanel"
                            aria-labelledby="home-tab">
                            <createAccount :records="records" :bankDetails = "bankDetails" :walletLimits = "walletLimits" @createAccount ="addAccount"/>
                        </div>
                        <div class="tab-pane fade" :class="{'show active' : tabStatus == 'Previous Account'}" id="mobile-use-previous-account-tab" role="tabpanel"
                            aria-labelledby="profile-tab">
                            <div class="amount-sec">
                                <div class="match-odds-list-sec" v-if="userAccounts && userAccounts.length">
                                    <PreviousAccount :userAccounts ="userAccounts" :records="records" :walletLimits = "walletLimits" @selectAmount = "selectAmount" @getPreviousBankDetails ="getPreviousBankDetails"/>
                                </div>
                                <div class="deposit top-cards_wrapper p-0 m-0" v-else>
                                    <div class="page-subtitle notes ps-2">
                                        <p>No Account Available. Continue with new account!!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="page-subtitle notes">
                        <p>1. This form is for withdrawing the amount from the main wallet only.</p>
                        <p>2. The bonus wallet amount cannot be withdrawn by this form.</p>
                        <p>3. Do not put Withdraw request without betting with deposit amount. Such activity
                            may
                            be identified as Suspicious</p>
                        <p>4. If multiple users are using same withdraw account then all the linked users
                            will
                            be blocked.</p>
                        <p>5. Maximum Withdraw time is 45 minutes then only complain on WhatsApp number.</p>
                        <p>6. Withdrawal account should be same to deposit account.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <HelpModal/>
    <WithdrawPasswordModal/>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { useVuelidate } from '@vuelidate/core';
export default {
    name: "WalletWithdraw",
    inject: ['walletLimits'],
    setup() {
		return { v$: useVuelidate() }
	},
    components: {
        HelpModal: defineAsyncComponent(() =>
            import('../components/HelpModal.vue')
        ),
        CreateAccount: defineAsyncComponent(() =>
            import('../components/CreateAccount.vue')
        ),
        PreviousAccount: defineAsyncComponent(() =>
            import('../components/PreviousAccount.vue')
        ),
        WithdrawPasswordModal: defineAsyncComponent(() =>
			import('../components/WithdrawPasswordModal.vue')
		)
    },
    data() {
        return {
            bankDetails:[],
            userAccounts:null,
            tabStatus: "New Account",
            accountData:null,
            records: {
                amount: null,
                bankId: null,
                holderName: null,
                accNo: null,
                ifscCode: null,
                withdrawPassword: null,
                termCondition: false
            },
        }
    },
    mounted() {
        this.getBankDetails();
        if(!this.$auth?.user?.is_withDraw_password){
            this.$helper.openModal('#newUserWithDrawPasswordModel');
        };
        this.tabSetting('Previous Account');
    },
    methods: {
       getBankDetails(){
        this.loading = true;
            this.$apiCall('get', 'BANK_DETAILS', null, 'user').then(response => {
                if (response) {
                    if (response.status == 200) {
                        this.bankDetails = response?.data?.data;
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error);
                }
            });
       },
       getPreviousBankDetails(){
        let data = {
                template_name: this.$siteSettings.data.template_name || 'lotus'
            }
            this.$apiCall('post', 'GET_USER_ACCOUNTS', data).then(response => {
                if (response?.status == 200) {
                    if (response?.data?.status == 0) {
                        this.$errorToast(response?.data?.debug[0]);
                    }
                    else {
                        this.userAccounts = response?.data?.data
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
       },
        selectAmount(amount) {
            let amounti = parseInt(this.records.amount) || 0;
            this.records.amount = parseInt(amount) + amounti;
        },

        addAccount(){
            this.$store.dispatch('setGlobalLoader', true);
            this.v$.$touch();
			if (this.v$.$error) {				
				this.$errorToast('Please fill the required fields');
                this.$store.dispatch('setGlobalLoader', false);
				return;
			}
            else{
                this.records.termCondition = true;
                if (!this.records.termCondition || this.records.termCondition == null) {
                    this.$errorToast('Please Accept Terms And Condition');
                    this.$store.dispatch('setGlobalLoader', false);
                    return
                } 
                if (!this.records.amount || this.records.amount < this.walletLimits?.withdraw_limit) {
                    this.$errorToast(`Minimum amount is ₹ ${this.walletLimits?.withdraw_limit}`);
                    this.$store.dispatch('setGlobalLoader', false);
                    return false;
                }
                if (this.records.amount > this.$auth.user.balance) {
                    this.$errorToast('Insufficient balance.');
                    this.$store.dispatch('setGlobalLoader', false);
                    return false;
                }                                  
                const userAccountData = new FormData();
                userAccountData.append('payment_method_id', 1);
                userAccountData.append('bank_id', this.records.bankId.id);
                userAccountData.append('bank_amount', this.records.amount);
                userAccountData.append('acc_no', this.records.accNo);
                userAccountData.append('holder_name', this.records.holderName);
                userAccountData.append('ifsc_code', this.records.ifscCode);
                userAccountData.append('withdraw_password', this.records.withdrawPassword);
                this.$apiCall('post', 'ADD_USER_ACCOUNT', userAccountData).then(response => {
                    if (response?.status == 200) {
                        if (response?.data?.error) {
                            this.$errorToast(response?.data?.error);
                            this.$store.dispatch('setGlobalLoader', false);
                        }
                        else {                        
                            this.withdrawWalletAmount({ 'bank_account_id': response.data.data.id, 'bank_amount': this.records.amount})
                            this.$successToast(response?.data?.message);
                        }
                    }
                }).catch(error => {
                    this.$store.dispatch('setGlobalLoader', false);
                    if (error) {
                        this.$errorToast(error[0]);
                    }
                });
            }
        },
       withdrawWalletAmount(data){
        this.$store.dispatch('setGlobalLoader', true);
            this.$apiCall('post', 'SUBMIT_WITHDRAW_AMOUNT', data).then(response => {
                if (response?.status == 200) {
                    if (response?.data?.error) {
                        this.$errorToast(response?.data?.error);
                    }
                    else {
                        this.$successToast(response?.data?.data + ' for amount of ' + data.bank_amount);
                        this.$router.push({name: 'Home'})
                    }
                    this.$store.dispatch('setGlobalLoader', false);
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        tabSetting(tabStatus) {
            this.tabStatus = tabStatus;
            if (tabStatus == "Previous Account") {
                this.getPreviousBankDetails();
            }
        },
    }
}
</script>

<style>
.withdraw-ui .nav-tabs .nav-link {
    font-size: 12px;
    height: 25px;
}
</style>